import React from "react";
import Layout from "../../../components/layout/layout";
import { MembersPage } from "../../../components/subscriptions/members-page";

export default function SubscriptionMembers({ component, ...rest }) {
  return <Layout Component={MembersPage} controlsDisabled={true} {...rest} />;
}
